import { msg } from "@omegagrid/localize";
import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import rp from '@reporting/rp-app-host';
import { AccountingGroup } from "@reporting/rp-types/core";

export class AccountingGroupFormAdapter extends FormAdapter {

	constructor(
		private accountingGroup: AccountingGroup
	) { super() }

	getColumns() {
		return [
			{width: 120},
			{width: null},
		];
	}

	async getControls() {
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'group_name'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'group_name', required: true, value: this.accountingGroup.group_name},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Domain'), for: 'user_domain'},
			{row: 1, col: 1, type: FormControlType.TextInput, key: 'user_domain', value: this.accountingGroup.user_domain},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Max users'), for: 'user_count'},
			{row: 2, col: 1, type: FormControlType.NumericInput, key: 'user_count', options: { min: 0, step: 1 }, value: this.accountingGroup.user_count},
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Login limit'), for: 'login_limit'},
			{row: 3, col: 1, type: FormControlType.NumericInput, key: 'login_limit', options: { min: 0, step: 1 }, value: this.accountingGroup.login_limit},
			{row: 4, col: 0, type: FormControlType.Label, value: msg('AI disabled'), for: 'disable_ai'},
			{row: 4, col: 1, type: FormControlType.Checkbox, key: 'disable_ai', value: !!this.accountingGroup.disable_ai},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		await rp.ms('accounting').post('groups', {
			id_group: this.accountingGroup.id_group,
			group_name: formValues.group_name as string,
			user_domain: formValues.user_domain as string,
			user_count: formValues.user_count as number,
			login_limit: formValues.login_limit as number,
			disable_ai: !!formValues.disable_ai,
		} as AccountingGroup);
		return true;
	}

};
